import { Component } from '@angular/core';
import { CardModule } from 'primeng/card';
import { InputTextModule } from 'primeng/inputtext';
import { CommonModule, Location } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { PasswordModule } from 'primeng/password';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { MessagesModule } from 'primeng/messages';

import { User } from '../../Models/user';
import { Router } from '@angular/router';
import { StorageService } from '../../../services/storage.service';
import { PlockapiService } from '../../../services/plockapi.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    CardModule,
    InputTextModule,
    ButtonModule,
    PasswordModule,
    IconFieldModule,
    InputIconModule,
    MessagesModule,
  ],
  providers: [Location],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent {
  messages: any;
  user: any;
  pass: any;
  loading: boolean = false;
  constructor(private router: Router, private storage: StorageService, private service: PlockapiService) {
  }

  login() {
    this.loading = true;
    let usr: any = { NombreUsuario: this.user, Password: this.pass };

    this.service.authenticateUser(usr).subscribe({
      next: (res) => {
        this.storage.storeUser(res);
        this.router.navigate(['/Terminal']);
        this.messages = [{ severity: 'success', detail: 'Datos validados!' }];
        this.loading = false;
      },
      error: (ex) => {
        this.loading = false;
        this.messages = [{ severity: 'error', detail: ex.error.Message }];
      }
    });
  }
}
